import { useAppSelectorV1 } from "@redux/hooks";
import { NavPoint } from "@redux/legacy-actions/navPoints";
import { selectPopulatedNavPoint } from "@redux/selectors/getters";

export default function useNavPoint(): NavPoint {
  return useAppSelectorV1(selectPopulatedNavPoint);
}
